import React from 'react';
import { motion } from 'framer-motion';

const Logo = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="flex items-center justify-center"
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="flex-shrink-0"
      >
        <h1 
          className="text-6xl font-bold"
          style={{
            background: 'linear-gradient(135deg, #60A5FA 0%, #3A86FF 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textShadow: '0 0 10px rgba(58, 134, 255, 0.5)'
          }}
        >
          DelF
        </h1>
      </motion.div>

      <motion.div className="flex-shrink-0 -ml-20">
        <svg width="150" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#60A5FA" />
              <stop offset="100%" stopColor="#3A86FF" />
            </linearGradient>
            <filter id="glow">
              <feGaussianBlur stdDeviation="2" result="blur" />
              <feFlood floodColor="#3A86FF" floodOpacity="0.5" result="color" />
              <feComposite in="color" in2="blur" operator="in" result="shadow" />
              <feComposite in="SourceGraphic" in2="shadow" operator="over" />
            </filter>
          </defs>

          <motion.g 
            animate={{ y: [0, -3, 0] }}
            transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
          >
            <path 
              d="M100 30c0 0-10-12-20-2c-10 10-5 30 0 35c5 5 15 10 20 0c5-10 5-15 0-20c-5-5-15-5-15-5" 
              stroke="url(#logoGradient)" 
              strokeWidth="4" 
              fill="none" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
            />
            <circle cx="85" cy="35" r="2" fill="#FFFFFF" />
            <path d="M80 43c0 0 5 0 7 5" stroke="#FFFFFF" strokeWidth="2" fill="none" strokeLinecap="round" />
          </motion.g>
        </svg>
      </motion.div>
    </motion.div>
  );
};

export default Logo;